<template>
  <div class="family">
    <div class="head">
      <div class="box">
        <p>{{ title }}</p>
      </div>
    </div>
    <div class="content">
      <div v-for="(item, index) in list" :key="index">
        <div
          :class="`item `"
          :style="{
            backgroundImage: `url(${item.cover})`,
            backgroundSize: `${item.width} ${item.height}`
          }"
          @click="goSite(item.url)"
        >
          <div class="mask">
            <h4>{{ item.name }}</h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { teamChines } from "@/util/text";
export default {
  data() {
    return {};
  },
  methods: {
    goSite(url) {
      if (url) {
        window.open(url);
      }
    }
  },
  computed: {
    ...mapGetters({ language: "getType" }),
    title() {
      return this.language == "中文" ? "成员企业" : "Wandering ";
    },
    list() {
      return this.language == "中文" ? teamChines : teamEnglis;
    }
  }
};
</script>

<style lang="less" scoped>
.family {
  position: relative;
  width: 100%;
  margin-top: 200px;
  .head {
    width: 100%;
    height: 315px;
    background: url("../assets/teambg.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .box {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;
      h4 {
        margin-top: 0px;
        font-size: 44px;
        color: rgba(255, 255, 255, 1);
        font-weight: normal;
      }
      p {
        font-size: 42px;
        margin-top: 40px;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .content {
    width: 1200px;
    margin: -200px auto 60px;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    align-content: flex-start;
    &::after {
      width: 300px;
      height: 196px;
    }

    .item {
      display: block;
      cursor: pointer;
      width: 285px;
      height: 196px;
      margin-top: 34px;
      margin-right: 12px;
      &::nth-of-type(4n) {
        margin-right: 0;
      }
      background-color: rgba(255, 255, 255, 1);
      background-repeat: no-repeat;
      background-position: center center;
      box-shadow: 3px 4px 21px 0px rgba(70, 214, 177, 0.24);
      border-radius: 15px;
      position: relative;
      overflow: hidden;

      &:hover {
        .mask {
          opacity: 1;
          top: 0;
          transition: 0.5s all ease;
        }
      }
      .mask {
        opacity: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 106, 0, 0.72);
        box-shadow: 3px 4px 21px 0px rgba(70, 214, 177, 0.24);
        border-radius: 15px;
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 10;
        box-sizing: border-box;
        padding: 20px 15px 0;
        h4 {
          font-size: 24px;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 10px;
        }
        p {
          font-size: 16px;
          text-align: center;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/family.vue